import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config/config.service';

@Injectable()
export class AuthorizeService {

  private client: HttpClient;

  constructor(private httpBackend: HttpBackend, private configService: ConfigService) {
    this.client = new HttpClient(httpBackend); // Bypass interceptors
  }

  public authorize(username: string, password: string): Observable<any> {
    const url = `${this.configService.config.rest.apiV2Url}/auth/login`;

    return this.client.post(url, { username: username, password: password });
  }
}
